import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 18l14 -6l-14 -6","key":"svg-0"}]]

const IconMathGreater = createReactComponent('outline', 'math-greater', 'MathGreater', __iconNode);

export default IconMathGreater;